import { User, Mail, Shield, KeyRound, Calendar } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const usersSchema = defineSchema({
  id: 'users',
  title: 'filter.users.title',
  subtitle: 'filter.users.subtitle',
  defaultField: 'name',
  fields: {
    name: {
      key: 'name',
      label: 'users.colName',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driver',
      description: 'filter.desc.userName',
      example: 'name:Yanick',
    },
    email: {
      key: 'email',
      label: 'users.colEmail',
      type: 'text',
      icon: Mail,
      placeholder: 'filter.placeholder.email',
      description: 'filter.desc.email',
      example: 'email:gmail.com',
    },
    role: {
      key: 'role',
      label: 'users.colRole',
      type: 'enum',
      icon: Shield,
      allowMultiple: true,
      description: 'filter.desc.userRole',
      options: [
        { value: 'admin', label: 'users.roleAdmin' },
        { value: 'owner', label: 'users.roleOwner' },
        { value: 'user', label: 'users.roleUser' },
      ],
      example: 'role:admin',
    },
    provider: {
      key: 'provider',
      label: 'users.colProvider',
      type: 'enum',
      icon: KeyRound,
      allowMultiple: true,
      description: 'filter.desc.authProvider',
      options: [
        { value: 'google', label: 'Google' },
        { value: 'apple', label: 'Apple' },
        { value: 'password', label: 'filter.provider.password' },
      ],
      example: 'provider:google',
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.userDate',
      example: 'from:-30d',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last7d', value: '-7d' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'Yanick', desc: 'filter.users.example1' },
    { q: 'role:admin', desc: 'filter.users.example2' },
    { q: 'provider:google from:-30d', desc: 'filter.users.example3' },
  ],
});
